import * as actionTypes from './actionsTypes';

export const setusername=(payload)=>{
    return {
        type:actionTypes.SETUSERNAME,
        value:payload
    }
}